import store from 'config/store'
import { isNil, omit, pathOr } from 'ramda'

export const generatePresenceContext = async () => {
  const { session, conversations } = store.getState()
  const pageInformation = omit(['href'], session.context.page)

  return {
    engagement: {
      activeConversation: conversations.endUserEngaged
    },
    page: pageInformation,
    location: _hydrateGeoPresenceData(session.geo),
    session: _hydrateSessionPresenceData(session.context, session.visitInformation)
  }
}

const _hydrateSessionPresenceData = (context: Record<string, any> = {}, visitCounts: Record<string, any> = {}) => {
  return {
    numPageViews: pathOr(0, ['total'], visitCounts),
    numSessions:  pathOr(0, ['total'], visitCounts),
    currentSessionStartedAt: context.currentSessionStartedAt,
    currentPageViewStartedAt: context.currentPageViewStartedAt,
    previousSessionStartedAt: pathOr(null, ['lastVisit'], visitCounts),
    previousSessionEndedAt: null,
    firstSessionAt: pathOr(null, ['firstVisit'], visitCounts),
    activeSessionStartedAt: context.activeSessionStartedAt
  }
}

const _hydrateGeoPresenceData = (context: Record<string, any> = {}) => {
  if (isNil(context)) {
    return {}
  }

  return {
    ip: context.ip,
    city: context.city,
    subdivision: context.subdivision,
    country: context.country,
    countryCode: context.countryCode,
    gdprApplicable: context.gdprApplicable,
    metroCode: context.metroCode,
    postalCode: context.postalCode,
    latLong: {
      lat: context.latitude,
      lon: context.longitude
    }
  }
}
